/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Sep 09 2021, 10:16:55
 *
 *******************************************************/
// @flow

import mixpanel from 'src/integrations/mixpanel';

/**
 * Common tracking of button/url clicks (in lots of places).
 *
 * Most texts are derived from EN translations.
 */
export const trackClick = (text: string = '') => {
  if (!text) {
    console.warn('[Tracking] No button/link clicked to be tracked!');
    return;
  }

  mixpanel.track('Click on Dashboard', { text });
};
